/* eslint-disable */

import React from 'react'
import { connect } from 'react-redux'
import { Field, FieldArray, reduxForm, change } from 'redux-form'
import styles from './TkAndCrpForms.css'
import FormSection from '../../../views/components/Common/FormSection/FormSection'
import { green } from '@material-ui/core/colors'
import Switch from '@material-ui/core/Switch'
import Checkbox from '@material-ui/core/Checkbox'
import SelectField from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import PhoneIcon from '@material-ui/icons/Phone'
import EmailIcon from '@material-ui/icons/Email'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Link from '@material-ui/core/Link'
import { withStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextInput from '../../containers/Forms/components/CrpTextInput'
import MaskedInput from '../../containers/Forms/components/CrpMaskedInput'
import ReactSelectDropdownInput from '../../containers/Forms/components/ReactSelectDropdownInput'
import {
  emailMask,
  requiredValidation,
  emailValidation,
  minLen1Validation,
  phoneValidationWith1Prefix,
  isValidNPI,
  castStringBooleanToBoolean,
} from '../../containers/Forms/components/formValidations'
import {
  getEmailFrequencyOptions,
  EMAIL_FREQUENCY_TYPES,
  DATASOURCES, FORMS } from '../../constants'
import Loading from '../../components/Loading'
import EditIcon from 'static/images/icons/pencil-outline.svg'
import CancelIcon from 'static/images/icons/delete-outline.svg'
import Popover from '../../containers/Popovers/components/Popover'
import { getDataSource } from '../../store/appReducer'
import { AVAILABILITY } from './constants'
import CheckboxInput from './components/CheckboxInput'
import CheckedIcon from 'static/images/icons/checkboxCheckedSquare.svg'
import UncheckedIcon from 'static/images/icons/checkboxUncheckedSquare.svg'
import CheckedDisabledIcon from 'static/images/icons/checkboxCheckedDisableSquare.svg'
import RadioButtonInput from './components/RadioButtonInput'
import RadioButton from './components/RadioButton'
import { Box, Typography } from '@material-ui/core'
import LicenseEditableTable from '../Tables/LicenseEditableTable'
import RadioButtonAvailability from './components/RadioButtonAvailability'
import CustomModal from '../../../views/components/Modal/CustomModal'
import WarningIcon from 'static/images/Warning.png'
import pluseIcon from 'static/images/Vector.png'
import { LICENSE_COVERED_AREAS, LICENSE_COVERED_COUNTRIES, LICENSE_COVERED_EU_REGION_COUNTRIES, getRegion } from 'legacy/constants'
import { checkTKFeatureEnabled, checkCRPFeatureEnabled } from 'configs'
import { FormattedMessage, injectIntl } from 'react-intl'

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />)

class EditMemberForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      disabled: {
        email: true,
        firstName: true,
        lastName: true,
        emailFrequency: true,
        phone: true,
        isDeactivateModalOpen: false,
      },
      userType: 0,
      deleteConfirmShow: false,
      isText: props.notificationData && props.notificationData.data && props.notificationData.data.result && props.notificationData.data.result.smsEnabled,
      isEmail: props.notificationData && props.notificationData.data && props.notificationData.data.result && props.notificationData.data.result.emailEnabled,
      isDisable: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.notificationData && this.props.notificationData.isFetching !== prevProps.notificationData.isFetching) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isText: this.props.notificationData && this.props.notificationData.data && this.props.notificationData.data.result && this.props.notificationData.data.result.smsEnabled,
        isEmail: this.props.notificationData && this.props.notificationData.data && this.props.notificationData.data.result && this.props.notificationData.data.result.emailEnabled,
      })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.submitSucceeded !== this.props.submitSucceeded && nextProps.submitSucceeded === true) {
      this.setState({
        disabled: {
          email: true,
          firstName: true,
          lastName: true,
          emailFrequency: true,
          phone: true,
        },
        deleteConfirmShow: false,
      })
    }
    if (!this.state.userType) {
      this.setState({ userType: 1 }, () => {
        const permissions = (this.props.editMemberFormData || {}).permissions || {}
        if (permissions.isAdmin) {
          this.updateUserType(true, true, null, 'permissions.isAdmin')
        }
        if (permissions.isPhysician) {
          this.updateUserType(true, true, null, 'permissions.isPhysician')
        }
      })
    }
  }

  toggleDisable = field => {
    this.setState(prevState => ({
      disabled: Object.assign(prevState.disabled, {
        [field]: !prevState.disabled[field],
      }),
    }))
  }

  // popover functions here for now, should move later
  // same as revoke on enrollment form
  toggleConfirmPopover = () => {
    this.setState(prevState => ({
      deleteConfirmShow: !prevState.deleteConfirmShow,
    }))
  }

  cancelDelete = () => {
    this.setState({
      deleteConfirmShow: false,
    })
  }

  onDeactivateModalClose = () => {
    this.setState({
      isDeactivateModalOpen: false,
    })
    this.props.handleOnDeactivateAccountClick({ isDeactivated: true })
  }

  updateUserType = (e, newValue, previousValue, name) => {
    const fieldName = name.split('.')[1]
    let newType = this.state.userType
    switch (fieldName) {
    case 'isPhysician':
      newType += (newValue ? 2 : -2)
      break
    case 'isAdmin':
      newType += (newValue ? 3 : -3)
      break
    default:
      break
    }
    // 1 = neither
    // 3 = physician
    // 4 = admin
    // 6 = physician and admin
    this.setState(prevState => ({
      ...prevState,
      userType: newType
    }))
  }

  isAdmin = () => {
    return this.state.userType === 4
  }
  isPhysician = () => {
    return this.state.userType === 3
  }
  isAdminPhysician = () => this.state.userType === 6

  CustomSwitch = withStyles({
    switchBase: {
      '&$checked': {
        color: '#2D9F86',
      },
      '&$checked + $track': {
        backgroundColor: '#2D9F86',
      },
    },
    checked: {},
    track: {},
  })(field => <Switch onChange={field.input.onChange} checked={field.input.value} {...field}/>)

  handleClick = () => {
    const { isEmail, isText } = this.state
    const data = {
      isEmail,
      isText,
    }
    this.props.handleAppointmentNotificationsChange(data)
  }

  renderSelectField = withStyles({
    select: {
      height: '10px',
      background: '#FFFFFF',
    },
  })(({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
  }) => (
    <FormControl size="small" variant="outlined" fullWidth>
      <InputLabel className={styles.label} style={{ marginBottom: '4px' }}>{label}</InputLabel>
      <SelectField
        floatingLabelText={label}
        errorText={touched && error}
        className={styles.selectFieldStyle}
        {...input}
        // eslint-disable-next-line react/no-children-prop
        children={children}
        {...custom}
      />
      {error && <span className={styles.error}>{error}</span>}
    </FormControl>
  ))


  render() {
    const {
      me,
      handleSubmit,
      invalid,
      pristine,
      submitting,
      isSubmitting,
      editMemberFormData,
      handleOnTeamMemberDeleteClick,
      isMe,
      showEmailReminder,
      showTKFeatureEnabled: tkEnabled,
      showCRPFeatureEnabled: crpEnabled,
      showRPMFeatureEnabled: rpmEnabled,
      setAccountActivate,
      setAccountDeactivate,
      isAccountDeactivate,
      handleOnReactivateAccountClick,
      handleOnDeactivateAccountClick,
      selectedTeamMemberId,
      initialValues,
      intl,
    } = this.props
    const {
      disabled,
      deleteConfirmShow,
    } = this.state
    const frequencyOptions = [ ...getEmailFrequencyOptions() ]
    const TKFeatureEnabled = checkTKFeatureEnabled(isMe)
    const CRPFeatureEnabled = checkCRPFeatureEnabled(isMe)
    const showDeactiveButton = true 

    const isNotNeverSelected = editMemberFormData && editMemberFormData.reminders && editMemberFormData.reminders.emailFrequency.id !== EMAIL_FREQUENCY_TYPES.NEVER

    const getEditClassName = field => (disabled[field] ? 'editIcon' : 'editIconActive')

    const isUsRegion = getRegion() === 'us'
    const coveredRegions = isUsRegion ? LICENSE_COVERED_COUNTRIES : LICENSE_COVERED_EU_REGION_COUNTRIES
    
    return (
      <React.Fragment>
        <form onSubmit={handleSubmit} disabled={(initialValues && initialValues.is_deactivated)} className={styles.updatePasswordForm} style={(initialValues && initialValues.is_deactivated) ? { opacity: '0.3', pointerEvents: 'none' } : {}}>
          <FormSection heading={<FormattedMessage id="heading.Member_Roles" />} style={{ padding: '2rem 3rem' }} required>
            <div className={styles.formSectionRow}>
              <div className={styles.checkboxWithDesc}>
                <Field
                  component={CheckboxInput}
                  labelClassName={styles.memberRole}
                  label={<FormattedMessage id="label.provider" />}
                  name="permissions.isPhysician"
                  description={<FormattedMessage id="description.provider" />}
                  onChange={this.updateUserType}
                  disabled={(initialValues && initialValues.is_deactivated) || isMe}
                  checkedIcon={<CheckedIcon className={styles.checkboxIcon}/>}
                  uncheckedIcon={<UncheckedIcon className={styles.checkboxIcon} />}
                  checkedDisabledIcon={<CheckedDisabledIcon className={styles.disabledCheckboxIcon} />}
                  uncheckedDisabledIcon={<UncheckedIcon className={styles.disabledCheckboxIcon} />}
                />
              </div>
              <div className={styles.checkboxWithDesc}>
                <Field
                  component={CheckboxInput}
                  labelClassName={styles.memberRole}
                  label={<FormattedMessage id="label.Account_Administrator" />}
                  name="permissions.isAdmin"
                  description={<FormattedMessage id="description.account_adminster" />}
                  onChange={this.updateUserType}
                  disabled={(initialValues && initialValues.is_deactivated) || isMe}
                  checkedIcon={<CheckedIcon className={styles.checkboxIcon}/>}
                  uncheckedIcon={<UncheckedIcon className={styles.checkboxIcon} />}
                  checkedDisabledIcon={<CheckedDisabledIcon className={styles.disabledCheckboxIcon} />}
                  uncheckedDisabledIcon={<UncheckedIcon className={styles.disabledCheckboxIcon} />}
                />
              </div>
            </div>
          </FormSection>
          
          { (tkEnabled || crpEnabled) && (
            <FormSection heading="Edit Member Information" style={{ padding: '2rem 3rem' }} required>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      label={<FormattedMessage id="label.first_name" />}
                      name="firstName"
                      placeholder="Enter First Name"
                      required={true}
                      validate={[ minLen1Validation, requiredValidation ]}
                    />
                </div>
                <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      label={<FormattedMessage id="label.last_name" />}
                      name="lastName"
                      placeholder="Enter Last Name"
                      required={true}
                      validate={[ minLen1Validation, requiredValidation ]}
                    />
                </div>
                <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      label={<FormattedMessage id="label.NPI" />}
                      name="npiNo"
                      placeholder="Enter NPI (If Applicable)"
                      validate={[ isValidNPI ]}
                      type="number"
                    />
                </div>
                <div className={styles.editLabelGroup}>
                      <Field
                        component={TextInput}
                        label={<FormattedMessage id="label.phone" />}
                        name="phone"
                        placeholder="Enter phone no"
                        required={true}
                        validate={
                          isUsRegion
                            ? [ requiredValidation, phoneValidationWith1Prefix ]
                            : [ requiredValidation ]
                        }
                        icon={<PhoneIcon />}
                      />
                </div>
              </div>
              <div className={
                  isUsRegion
                    ? `${styles.formSectionRow}`
                    : `${styles.formSectionRow} ${styles.contentJustify}`
                }>
                <div className={styles.editLabelGroup}>
                <Field
                  component={MaskedInput}
                  mask={emailMask}
                  placeholder="name@example.com"
                  label={<FormattedMessage id="label.email" />}
                  name="email"
                  required={true}
                  icon={<EmailIcon />}
                  validate={[ emailValidation, minLen1Validation, requiredValidation ]}
                />
                </div>
                <div className={styles.editLabelGroup}>
                    <InputLabel className={styles.label} style={{ marginBottom: '4px' }}>{isUsRegion ? <FormattedMessage id="label.Country" /> : <FormattedMessage id="label.Region" />}</InputLabel>
                    <Field name="country" component={this.renderSelectField}>
                      {  coveredRegions.map((item, i) => <MenuItem key={i} value={item.code}>{item.name}</MenuItem>)}
                    </Field>
                </div>
                {isUsRegion && <div className={styles.editLabelGroup}>
                    <InputLabel className={styles.label} style={{ marginBottom: '4px' }}><FormattedMessage id="label.State_or_region" /></InputLabel>
                    <Field name="region" component={this.renderSelectField}>
                      {LICENSE_COVERED_AREAS.map((item, i) => <MenuItem key={i} value={item.code}>{item.name}</MenuItem>)}
                    </Field>
                </div>}
              </div>
            </FormSection>
          )}

          { (!tkEnabled && !crpEnabled) && (
            <FormSection heading="Member Information" style={{ padding: '2rem 3rem' }} required>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      label={<FormattedMessage id="label.first_name" />}
                      name="firstName"
                      placeholder="Enter First Name"
                      required={true}
                      validate={[ minLen1Validation, requiredValidation ]}
                    />
                </div>
                <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      label={<FormattedMessage id="label.last_name" />}
                      name="lastName"
                      placeholder="Enter Last Name"
                      required={true}
                      validate={[ minLen1Validation, requiredValidation ]}
                    />
                </div>
                <div className={styles.editLabelGroup}>
                <Field
                  component={MaskedInput}
                  mask={emailMask}
                  placeholder="name@example.com"
                  label={<FormattedMessage id="label.email" />}
                  name="email"
                  required={true}
                  icon={<EmailIcon />}
                  validate={[ emailValidation, minLen1Validation, requiredValidation ]}
                />
                </div>
              </div>
            </FormSection>
          )}
         
          {this.isPhysician() && (tkEnabled || crpEnabled) && (
            <FormSection heading="Manage Availability" style={{ padding: '2rem 3rem' }}>
              <div className={styles.formSectionRow}>
                <div className={styles.checkboxWithDesc}>
                  <Field
                    component={RadioButtonAvailability}
                    name="canManageAvailability"
                    options={AVAILABILITY}
                    props={{ value: AVAILABILITY }}
                    normalize={castStringBooleanToBoolean}
                  />
                </div>
                <div className={styles.placeholder} />
              </div>
            </FormSection>
          )}
          {(this.isPhysician() || this.isAdminPhysician()) && (tkEnabled || crpEnabled) && (
            <FormSection heading={<FormattedMessage id="heading.License_Information" />}>
              <div style={{ flexDirection: 'column' }} className={styles.formSectionRow}>
                <LicenseEditableTable viewOnly={false} me={me} />
              </div>
            </FormSection>
          )}
          {
            (tkEnabled || crpEnabled) && (
              <React.Fragment>
                <h2 style={{ marginLeft: 0 }} className={styles.formTitle}><FormattedMessage id="heading.Appointment_Notifications" /></h2>
                <div className={styles.formSection}>
                  <div style={{ justifyContent: 'unset' }} className={styles.formSectionRow}>
                    <React.Fragment>
                      <div style={{ width: '10%' }} className={styles.checkboxWithDesc}>
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={this.state.isText}
                              onChange={e => {
                                this.setState({
                                  isText: e.target.checked,
                                  isDisable: true,
                                })
                              }}
                              name="isText"
                            />
                          }
                          label={<FormattedMessage id="label.Text" />}
                        />
                      </div>
                      <div className={styles.checkboxWithDesc}>
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={this.state.isEmail}
                              onChange={e => {
                                this.setState({
                                  isEmail: e.target.checked,
                                  isDisable: true,
                                })
                              }}
                              name="isEmail"
                            />
                          }
                          label={<FormattedMessage id="label.email" />}
                        />
                      </div>
                      <div className={styles.placeholder} />
                    </React.Fragment>
                  </div>
                </div>
              </React.Fragment>
            )
          }

          {showEmailReminder && (
            <React.Fragment>
              <h2 className={styles.formTitle}><FormattedMessage id="heading.Email_Reminder_line1" /></h2>
              <h3 className={styles.formSubtitle}><FormattedMessage id="heading.Email_Reminder_line2" /></h3>
              <div className={styles.editMemberSection}>
                <div className={styles.formSectionRow}>
                  <div className={styles.editLabelGroup}>
                    <div className={styles[getEditClassName('emailFrequency')]} onClick={() => this.toggleDisable('emailFrequency')}>
                      <EditIcon />
                    </div>
                    <Field
                      component={ReactSelectDropdownInput}
                      label={<FormattedMessage id="label.Frequency_of_reminders" />}
                      name="reminders.emailFrequency"
                      isClearable={false}
                      backspaceRemovesValue={false}
                      options={frequencyOptions}
                      getOptionLabel={p => {
                        const type = typeof p.label === 'string' ? p.label.toLowerCase() : null
                        return type ? intl.formatMessage({
                          id: `label.frequency.${type}`
                        }) : p.label 
                      }}
                      getOptionValue={p => p.id}
                      disabled={disabled.emailFrequency}
                    />
                    {isNotNeverSelected &&
                    <div className={styles.emailRules}>
                      <div className={styles.emailRulesLabelFirst}><FormattedMessage id="app.SideNav.ECGInbox" /></div>
                      <Field
                        component={CheckboxInput}
                        label={<FormattedMessage id="label.ECGs_to_review_in_Personal_Inbox" />}
                        name="reminders.personalReminder"
                        disabled={!(isNotNeverSelected && !disabled.emailFrequency)}
                      />
                      <Field
                        component={CheckboxInput}
                        label={<FormattedMessage id="label.ECGs_to_review_in_Practice_Inbox" />}
                        name="reminders.triageReminder"
                        disabled={!(isNotNeverSelected && !disabled.emailFrequency)}
                      />
                      <div className={styles.emailRulesLabel}><FormattedMessage id="app.SideNav.Reports" /></div>
                      <Field
                        component={CheckboxInput}
                        label={<FormattedMessage id="label.Reports_tobe_signed_by_provider" />}
                        name="reminders.personalEsignReportReminder"
                        disabled={!(isNotNeverSelected && !disabled.emailFrequency)}
                      />
                      <Field
                        component={CheckboxInput}
                        label={<FormattedMessage id="label.Reports_tobe_signed_in_practice" />}
                        name="reminders.teamEsignReportReminder"
                        disabled={!(isNotNeverSelected && !disabled.emailFrequency)}
                      />
                      <Field
                        component={CheckboxInput}
                        label={<FormattedMessage id="label.Reports_tobe_exported" />}
                        name="reminders.teamExportReportReminder"
                        disabled={!(isNotNeverSelected && !disabled.emailFrequency)}
                      />
                    </div>
                    }
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          <div className={styles.editMemberSubmitWrapper} style={{ display: 'flex', justifyContent: 'space-between' }}>
            { false && showDeactiveButton &&
              <div>
                <Button style={{ color: 'red' }} onClick={() => this.setState({ isDeactivateModalOpen: true })}>
                  <FormattedMessage id="button.Deactivate_account" />
                </Button>
              </div>
            }
            {!isMe &&
              <div>
                <button type="button" className={styles.submit} onClick={() => this.toggleConfirmPopover()}>
                  <CancelIcon /> <FormattedMessage id="button.delete" />
                </button>
                {deleteConfirmShow &&
                  <Popover onOutsidePopoverClick={() => this.cancelDelete()} className={styles.dropover}>
                    <div className={styles.dropoverContent}>
                      <h2><FormattedMessage id="confirmation.about_to_delete_member_line1" /></h2>
                      <p><FormattedMessage id="confirmation.about_to_delete_member_line2" /></p>
                    </div>
                    <div className={styles.dropoverControls}>
                      <a onClick={() => this.cancelDelete()}><FormattedMessage id="button.cancel" /></a>
                      <a onClick={handleOnTeamMemberDeleteClick}><FormattedMessage id="label.ok" /></a>
                    </div>
                  </Popover>
                }
              </div>
            }

            <div className={styles.buttonWrapper}>
              {!pristine && (submitting || isSubmitting) ?
                <button disabled className={styles.submitLoading}>
                  <Loading />
                </button>
                :
                <button
                  type="submit"
                  onClick={() => { if (tkEnabled || crpEnabled) this.handleClick() }}
                  disabled={this.state.isDisable ? !this.state.isDisable : invalid || pristine}
                  className={styles.submit}
                >
                  <FormattedMessage id="button.save_changes" />
                </button>
              }
            </div>
          </div>
        </form>
        <CustomModal
          modalType="confirm"
          open={this.state.isDeactivateModalOpen}
          closeModalHandler={() => { this.setState({ isDeactivateModalOpen: false }) }}
          icon={WarningIcon}
          iconAltText="Warning Icon"
          heading={<FormattedMessage id="confirmation.deactivate_member" values={{
            firstName: initialValues && initialValues.firstName,
            lastName: initialValues && initialValues.lastName,
          }}/>}
          descriptionLine1={<FormattedMessage id="description.deactivate_member" />}
          descriptionLine2=""
          confirmHandler={e => this.onDeactivateModalClose()}
          confirmButtonText={<FormattedMessage id="button.Yes_deactivate" />}
          declineButtonText={<FormattedMessage id="button.cancel" />}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  notificationData: getDataSource(state, DATASOURCES.MEMBER_NOTIFICATION_SETTINGS),
})
const EditMemberFormWithIntl = injectIntl(EditMemberForm)
const decoratedComponent = connect(mapStateToProps, null)(EditMemberFormWithIntl)

export default reduxForm({
  form: 'editMemberForm',
  enableReinitialize: true,
})(decoratedComponent)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/EditMemberForm.jsx